<div class="tax-info-print" *ngIf="printableRecords?.length">
  <div class="text-align-right" edsSpacing="lg">
    {{ todayDate }}
  </div>

  <!--Main title-->
  <eds-title [level]="1" size="h1" edsSpacing="lg">
    {{ "products.us-tax-info-page-heading" | translate }}
    {{ printableRecords[0]?.taxYear }}</eds-title
  >
  <eds-proximal edsSpacing="lg" placement="USTaxInfoPDFTop"></eds-proximal>

  <!--table container-->
  <eds-panel [hasPadding]="false" *ngFor="let record of printableRecords">
    <!--fund header-->
    <eds-title [level]="2" size="h2" edsSpacing="md">{{
      record.fundName
    }}</eds-title>

    <!--responsive table-->
    <table class="tax-info-print-table" role="table" edsSpacing="lg">
      <caption class="tax-info-print-table__caption">
        {{
          "products.us-tax-info-page-additional-section" | translate
        }}
      </caption>
      <tbody class="tax-info-print-table__tbody">
        <tr class="tax-info-print-table__tr">
          <th class="tax-info-print-table__th">
            {{ "products.us-tax-info-page-foreignsourceincome" | translate }}
          </th>
          <td class="tax-info-print-table__td">
            {{ record.foreignSourceIncome }}
          </td>
        </tr>
        <tr class="tax-info-print-table__tr">
          <th class="tax-info-print-table__th">
            {{
              "products.us-tax-info-page-foreignsourcequalifieddividends"
                | translate
            }}
          </th>
          <td class="tax-info-print-table__td">
            {{ record.foreignSourceQualifiedDividends }}
          </td>
        </tr>
        <tr class="tax-info-print-table__tr">
          <th class="tax-info-print-table__th">
            {{
              "products.us-tax-info-page-directusgovernmentobligations"
                | translate
            }}
          </th>
          <td class="tax-info-print-table__td">
            {{ record.directUSGovernmentObligations }}
          </td>
        </tr>
        <tr class="tax-info-print-table__tr">
          <th class="tax-info-print-table__th">
            {{
              "products.us-tax-info-page-specifiedpvtactivitybondinterest"
                | translate
            }}
          </th>
          <td class="tax-info-print-table__td">
            {{ record.specifiedPvtActivityBondInterest }}
          </td>
        </tr>
        <tr class="tax-info-print-table__tr">
          <th class="tax-info-print-table__th">
            {{
              "products.us-tax-info-page-dividendsreceiveddeduction" | translate
            }}
          </th>
          <td class="tax-info-print-table__td">
            {{ record.dividendsReceivedDeduction }}
          </td>
        </tr>
        <tr class="tax-info-print-table__tr">
          <th class="tax-info-print-table__th">
            {{ "products.us-tax-info-page-section163" | translate }}
          </th>
          <td class="tax-info-print-table__td">{{ record.section163 }}</td>
        </tr>
        <tr class="tax-info-print-table__tr">
          <th class="tax-info-print-table__th">
            {{
              "products.us-tax-info-page-indianaresidenttaxableincome"
                | translate
            }}
          </th>
          <td class="tax-info-print-table__td">
            {{ record.indianaResidentTaxableIncome }}
          </td>
        </tr>
        <tr class="tax-info-print-table__tr">
          <th class="tax-info-print-table__th">
            {{
              "products.us-tax-info-page-utahresidenttaxableincome" | translate
            }}
          </th>
          <td class="tax-info-print-table__td">
            {{ record.utahResidentTaxableIncome }}
          </td>
        </tr>
      </tbody>
    </table>
    <table
      class="tax-info-print-table"
      role="table"
      edsSpacing="lg"
      *ngIf="record.stateFlag"
    >
      <caption class="tax-info-print-table__caption">
        {{
          "products.us-tax-info-page-stateflag" | translate
        }}
      </caption>
      <tbody class="tax-info-print-table__tbody">
        <tr
          class="tax-info-print-table__tr"
          *ngFor="let state of record.taxExemptData"
        >
          <th class="tax-info-print-table__th">{{ state.label }}</th>
          <td class="tax-info-print-table__td">{{ state.val }}</td>
        </tr>
      </tbody>
    </table>
  </eds-panel>
  <eds-proximal edsSpacing="lg" placement="USTaxInfoPDFBottom"></eds-proximal>
</div>
